/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationLargeGroupLimit200Response
 */
export interface GetReservationLargeGroupLimit200Response {
    /**
     * 
     * @type {number}
     * @memberof GetReservationLargeGroupLimit200Response
     */
    groups: number;
    /**
     * 
     * @type {number}
     * @memberof GetReservationLargeGroupLimit200Response
     */
    time: number;
}

/**
 * Check if a given object implements the GetReservationLargeGroupLimit200Response interface.
 */
export function instanceOfGetReservationLargeGroupLimit200Response(value: object): value is GetReservationLargeGroupLimit200Response {
    if (!('groups' in value) || value['groups'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    return true;
}

export function GetReservationLargeGroupLimit200ResponseFromJSON(json: any): GetReservationLargeGroupLimit200Response {
    return GetReservationLargeGroupLimit200ResponseFromJSONTyped(json, false);
}

export function GetReservationLargeGroupLimit200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationLargeGroupLimit200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'groups': json['groups'],
        'time': json['time'],
    };
}

export function GetReservationLargeGroupLimit200ResponseToJSON(json: any): GetReservationLargeGroupLimit200Response {
    return GetReservationLargeGroupLimit200ResponseToJSONTyped(json, false);
}

export function GetReservationLargeGroupLimit200ResponseToJSONTyped(value?: GetReservationLargeGroupLimit200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groups': value['groups'],
        'time': value['time'],
    };
}

